import { useEffect, useState } from 'react';
import { Alert, Button, Card, Space, Typography } from 'antd';
import { loginWith } from '../api/client';
import { SITE } from '@newsmedia/shared';

/** 從網址讀取登入錯誤訊息（被閘門拒絕時由後端帶回 ?login_error=...）。 */
function useLoginError(): string | null {
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const msg = params.get('login_error');
    if (msg) {
      setError(msg);
      params.delete('login_error');
      const qs = params.toString();
      window.history.replaceState(
        {},
        '',
        window.location.pathname + (qs ? `?${qs}` : ''),
      );
    }
  }, []);
  return error;
}

const PROVIDERS = [
  { key: 'line', label: '使用 LINE 登入', color: '#06C755' },
  { key: 'google', label: '使用 Google 登入', color: '#4285F4' },
  { key: 'yahoo', label: '使用 Yahoo 登入', color: '#6001D2' },
] as const;

/** 登入頁：三方登入按鈕（一帳號可多種登入方式）。 */
export default function LoginPage() {
  const loginError = useLoginError();
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <Card className="w-[360px] shadow-md">
        <Typography.Title level={3} className="!mb-1 text-center">
          {SITE.name} 後台
        </Typography.Title>
        <Typography.Paragraph type="secondary" className="text-center">
          請選擇登入方式
        </Typography.Paragraph>
        {loginError && (
          <Alert type="error" showIcon className="!mb-4" message={loginError} />
        )}
        <Space direction="vertical" className="w-full" size="middle">
          {PROVIDERS.map((p) => (
            <Button
              key={p.key}
              block
              size="large"
              style={{ background: p.color, color: '#fff', border: 'none' }}
              onClick={() => loginWith(p.key)}
            >
              {p.label}
            </Button>
          ))}
        </Space>
      </Card>
    </div>
  );
}
